import React, { useEffect } from "react";

import { CookieList } from "../../components/cookie-list";
import { FeatureList } from "../../components/feature-list";
import { Header } from "../../components/header/header";
import { IconButton } from "../../components/icon-button";

import { useBusyBlockerContext } from "../../contexts/busy-blocker-context";
import "./features-screen.css";

function onClick() {
	const previousHref = window.document.referrer;

	if (previousHref.includes("mobilecreator")) {
		const searchParams = new URLSearchParams(window.location.search);
		searchParams.delete("screen");

		window.location.search = searchParams.toString();
	} else {
		// Redirected from Desktop Creator
		window.history.back();
	}
}

export const FeaturesScreen = () => {
	const { busyBlocker } = useBusyBlockerContext();

	useEffect(() => {
		busyBlocker.while(Promise.resolve()).catch(() => undefined);
	}, [busyBlocker]);

	return (
		<div className="features-screen">
			<Header left={<IconButton iconName="arrow-left" onClick={onClick} />}>Features</Header>

			<div className="features">
				<FeatureList />
				<CookieList />
			</div>
		</div>
	);
};
FeaturesScreen.displayName = "FeaturesScreen";
